import { useState } from "react";
import { IForm } from "../../";
import VehicleChildForm from "./components/vehicleChildForm";
import { requiredFieldsByStep } from "./utils/required-fields-by-step";
import DealershipChildForm from "./components/dealershipChildForm";
import ServiceChildForm from "./components/serviceChildForm";
import ErrorDialog from "../../../../components/dialogs/ErrorDialog";
import SuccessDialog from "../../../../components/dialogs/SuccessDialog";
import {
  OccurrenceStepEnum,
  OccurrenceStepLabelEnum,
} from "../../../../enums/occurrenceStep";
import { fieldsLabels } from "./utils/fields-labels";
import { Occurrence } from "../../../../models/occurrence";
import { FinalizeOccurrenceButton } from "../../dialogs/finalizationReasonDialog";

const AnalysisWarrantyForm = (props: IForm) => {
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [hasError, setHasError] = useState(false);

  const requiredServiceFields = props.occurrence?.scheduleNumber
    ? requiredFieldsByStep.ANALYSIS_WARRANTY_PREVENTIVE_CHECKUP
    : requiredFieldsByStep.ANALYSIS_WARRANTY;

  return (
    <div>
      <div className="text-size-h4 font-bold">Análise e Garantia</div>
      <div className="text-color-status-resting text-size-14">
        Atribua os dados para relacionar a etapa de análise e garantia
      </div>

      <VehicleChildForm
        occurrence={props.occurrence}
        setOccurrenceValue={props.setOccurrenceValue}
        hiddenFields={["assetId"]}
        disabledFields={[]}
        disabledAllFields={true}
        requiredFields={[]}
        setOccurrenceStepValue={props.setOccurrenceStepValue}
        hasError={hasError}
        scheduling={props.scheduling}
      />

      <DealershipChildForm
        occurrence={props.occurrence}
        setOccurrenceValue={props.setOccurrenceValue}
        hiddenFields={[
          "dealershipId",
          "dealershipUniqueId",
          "dealershipLocation",
          "dealershipRepresentative",
          "dealershipRegional",
          "dealershipPhone",
          "dealershipDemarcatedArea",
        ]}
        disabledFields={[]}
        disabledAllFields={true}
        requiredFields={[]}
        setOccurrenceStepValue={props.setOccurrenceStepValue}
        hasError={hasError}
      />

      <ServiceChildForm
        occurrence={props.occurrence}
        setOccurrenceValue={props.setOccurrenceValue}
        hiddenFields={[
          "timeOpenProtocol",
          "country",
          "driverCheckInDriver",
          "mechanicLocation",
          "towTruckLocation",
          "vehiclePayloadType",
          "vehicleMaximumPayload",
          "vehicleCriticalPayload",
          "partOrderStatus",
          "checklist",
          "solutionProposed",
        ]}
        disabledFields={[
          "estimateTimeRepair",
          "criticality",
          "createdBy",
          "occurrenceType",
          "source",
          "modules",
          "hasLink",
          "mainOccurrence",
          "literatureDiagnosis",
          "literatureTroubleshooting",
          "tasNumber",
          "tasStatus",
          "serviceBaySchedule",
        ]}
        disabledAllFields={props.disabledAllFields}
        requiredFields={requiredServiceFields}
        step={props.step}
        setOccurrenceStepValue={props.setOccurrenceStepValue}
        partners={props.partners}
        hasError={hasError}
        persona={props.persona}
        scheduling={props.scheduling}
      />

      <hr className="my-6" />

      {props.persona !== "MANAGER" &&
        !props.finalized &&
        !props.hiddenSaveButton && (
          <div className="flex justify-end">
            <button
              className={`btn btn-primary ${
                props.loading ? "btn-loading disabled" : ""
              }`}
              type="button"
              onClick={async () => {
                if (!props.occurrence) return;
                const isValid = props.isValidStep(requiredServiceFields);
                setHasError(!isValid);
                if (!isValid) {
                  return;
                }
                const success = await props.save(props.occurrence);
                if (success) {
                  setShowSuccessDialog(true);
                } else {
                  setShowErrorDialog(true);
                }
              }}
              disabled={props.loading || props.disabledAllFields}
            >
              Salvar
            </button>

            <FinalizeOccurrenceButton
              occurrence={props.occurrence}
              finishOccurrence={props.finishOccurrence}
              disabledAllFields={props.disabledAllFields}
              stepId={props.step?.id}
            />
          </div>
        )}

      <ErrorDialog
        show={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        title="Erro ao salvar"
        body="Ocorreu um erro ao salvar a etapa de análise e garantia. Por favor, tente novamente ou entre em contato com o suporte."
      />

      <SuccessDialog
        show={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        title="Sucesso"
        body={
          <div className="space-y-4">
            <div>A etapa de análise e garantia foi salva com sucesso.</div>
            {!hasError && (
              <div>
                Deseja avançar para a etapa{" "}
                {OccurrenceStepLabelEnum.CUSTOMER_OK}?{" "}
              </div>
            )}
            {hasError && (
              <>
                <div>
                  É necessário preencher todos os campos obrigatórios para
                  avançar/retroceder de etapa.
                </div>
                <div>Campos obrigatórios não preenchidos:</div>
                <ul className="list-disc list-inside">
                  {props
                    .getNotFilledRequiredFields(
                      requiredServiceFields,
                      props.occurrence ?? ({} as Occurrence)
                    )
                    .map((field: string) => (
                      <li key={field}>
                        {fieldsLabels[field as keyof typeof fieldsLabels]}
                      </li>
                    ))}
                </ul>
              </>
            )}
          </div>
        }
        footer={
          <button
            className="btn btn-primary"
            disabled={hasError || !props.changeStep || !props.occurrence}
            onClick={() => {
              props.summaryStep?.id && props.changeStep!(
                props.occurrence!,
                props.summaryStep.id,
                OccurrenceStepEnum.CUSTOMER_OK
              );
              setShowSuccessDialog(false);
              props.onClose();
            }}
          >
            Avançar etapa
          </button>
        }
      />
    </div>
  );
};

export default AnalysisWarrantyForm;
